import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="border-t border-sand-100 bg-white">
      <div className="container-wide py-12">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-sage-600">
                <svg viewBox="0 0 24 24" className="h-5 w-5 text-white" fill="currentColor">
                  <circle cx="12" cy="6" r="3" />
                  <path d="M12 9v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
              <span className="text-lg font-semibold text-sand-900">GolfBook</span>
            </Link>
            <p className="mt-4 text-sm text-sand-500">
              Book tee times at premium courses. Earn rewards with every round.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-sand-900">Quick Links</h3>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/tee-times" className="text-sm text-sand-500 hover:text-sand-700">
                  Book Tee Time
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-sm text-sand-500 hover:text-sand-700">
                  Pro Shop
                </Link>
              </li>
              <li>
                <Link to="/loyalty" className="text-sm text-sand-500 hover:text-sand-700">
                  Loyalty Rewards
                </Link>
              </li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h3 className="text-sm font-semibold text-sand-900">Account</h3>
            <ul className="mt-4 space-y-3">
              <li>
                <Link to="/login" className="text-sm text-sand-500 hover:text-sand-700">
                  Sign In
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-sm text-sand-500 hover:text-sand-700">
                  Create Account
                </Link>
              </li>
              <li>
                <Link to="/bookings" className="text-sm text-sand-500 hover:text-sand-700">
                  My Bookings
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-sand-900">Contact</h3>
            <ul className="mt-4 space-y-3">
              <li className="text-sm text-sand-500">
                support@golfbook.com
              </li>
              <li className="text-sm text-sand-500">
                1-800-GOLF-TEE
              </li>
              <li className="text-sm text-sand-500">
                Mon-Sun 6am-8pm EST
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-sand-100 pt-8 sm:flex-row">
          <p className="text-sm text-sand-400">
            &copy; {new Date().getFullYear()} GolfBook. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-sm text-sand-400 hover:text-sand-600">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-sand-400 hover:text-sand-600">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
